import _ from "lodash";
// Helper function for opening windows with family searches
const openFamilyWindows = async (families, colSet) => {
  for (const family of families) {
    await new Promise((r) => setTimeout(r, 2000));
    if (family !== "") {
      // Create query parameters using URLSearchParams
      const params = new URLSearchParams();
      params.append("tab", "all");

      if (colSet) {
        params.append("colset", colSet);
      }

      // Add column searches in a flat format that's still iterable
      params.append(
        "listingColumnSearches[product_families_view.families]",
        family
      );
      params.append(
        "inventoryColumnSearches[supply_families_view.families]",
        family
      );

      // Build final URL
      const url = `/datatables/pricetool?${params.toString()}`;
      window.open(url, "_blank");
    }
  }
};

export const openFamiliesProduct = (datatable, colSet) => {
  const datas = datatable.rows({ selected: true }).data();

  _.each(datas, async function (row) {
    if (
      row["product_families_view"]["families"] &&
      row["product_families_view"]["families"].length > 0
    ) {
      let families = row["product_families_view"]["families"]
        .split(",")
        .map((fam) => fam.trim());

      await openFamilyWindows(families, colSet);
    }
  });
};

export const openListing = (datatable, colSet) => {
  const datas = datatable.rows({ selected: true }).data().toArray();

  const asins = [
    ...new Set(
      datas.map((row) => row["product"]["product_asin"]).filter(Boolean)
    ),
  ];

  asins.forEach((asin) => {
    const url = `?tab=all&listingColumnSearches[product.product_asin]=${asin}&inventoryColumnSearches[inventory_associated_product_asins_view.product_asins]=${asin}`;
    window.open(url, "_blank");
  });
};

export const openFamiliesSupply = (datatable, colSet) => {
  const datas = datatable.rows({ selected: true }).data();

  _.each(datas, async function (row) {
    if (
      row["supply_families_view"]["families"] &&
      row["supply_families_view"]["families"].length > 0
    ) {
      let families = row["supply_families_view"]["families"]
        .split(",")
        .map((fam) => fam.trim());

      await openFamilyWindows(families, colSet);
    }
  });
};

export const openInLink = (
  datatable,
  urlStart,
  tableName,
  columnName,
  urlEnd
) => {
  const datas = datatable.rows({ selected: true }).data();

  _.each(datas, (row) => {
    if (row[tableName] && row[tableName][columnName]) {
      window.open(urlStart + row[tableName][columnName] + urlEnd, "_blank");
    } else if (row["supply"] && row["supply"]["upc"]) {
      window.open(urlStart + row["supply"]["upc"] + urlEnd, "_blank");
    }
  });
};
